import { observer } from 'mobx-react'
import './index.scss'
import { ReactComponent as SliderArrow } from '../../../../assets/news/Rectangle 28.svg'
import { ReactComponent as FB } from '../../../../assets/socials/akar-icons_facebook-fill.svg'
import { ReactComponent as Telegram } from '../../../../assets/socials/telegram.svg'
import { ReactComponent as Linkedin } from '../../../../assets/socials/akar-icons_linkedin-fill.svg'
import { ReactComponent as Tw } from '../../../../assets/socials/akar-icons_twitter-fill.svg'
import { getShortDate } from '../../../../hooks/dateOutputs'
import { useNavigate } from 'react-router'
import ContentState from '../../../../stores/ContentState'
import GlobalState from '../../../../stores/GlobalState'
const PostContent = observer(() => {
  const navigate = useNavigate()
  if (!ContentState.newsPost) return <></>

  let lang = GlobalState.currentLocale.lang.includes('En')
    ? '/en'
    : GlobalState.currentLocale.lang.includes('ру')
    ? '/ru'
    : ''

  const content: any = ContentState.newsPost
  return (
    <section className="post-content">
      <div className="post-content__aside">
        <div className="post-content__aside-area">
          <div
            className="post-content__back"
            onClick={() => navigate(`${lang}/news`)}
          >
            <SliderArrow />
            <span>{content.all}</span>
          </div>
          <div className="post-content__socials">
            <div className="post-content__socials-title">
              {content.shareTitle}
            </div>
            <div className="post-content__socials-list">
              <div className="post-content__socials-item">
                {' '}
                <FB
                  onClick={() =>
                    window.open(
                      `http://www.facebook.com/sharer.php?s=100&p[url]=${window.location.href}`,
                      '__blank',
                    )
                  }
                />
              </div>
              <div className="post-content__socials-item">
                {' '}
                <Telegram
                  onClick={() =>
                    window.open(
                      `https://telegram.me/share/url?url=${window.location.href}`,
                      '__blank',
                    )
                  }
                />
              </div>
              <div className="post-content__socials-item">
                {' '}
                <Tw
                  onClick={() =>
                    window.open(
                      `https://twitter.com/intent/tweet?url=${window.location.href}`,
                      '__blank',
                    )
                  }
                />
              </div>
              <div className="post-content__socials-item">
                {' '}
                <Linkedin
                  onClick={() =>
                    window.open(
                      `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}`,
                      '__blank',
                    )
                  }
                />
              </div>{' '}
            </div>
          </div>
        </div>
      </div>
      <div className="post-content__content">
        <div className="post-content__content-top">
          <div
            className="post-content__back"
            onClick={() => {
              navigate(`${lang}/news`)
            }}
          >
            <SliderArrow />
            <span>{content.all}</span>
          </div>
        </div>
        <div className="post-content__top">
          <div className="post-content__topic">{content.topic}</div>
          <div className="post-content__date">
            {getShortDate(
              new Date(content.date).getTime(),
              content,
              GlobalState.currentLocale.lang,
            )}
          </div>
        </div>
        <h1 className="post-content__title">{content.title}</h1>
        <img src={content.img} />
        <div
          className="post-content__col"
          dangerouslySetInnerHTML={{ __html: content.block }}
        ></div>
      </div>
    </section>
  )
})

export default PostContent
